import { render, staticRenderFns } from "./DonationDetail.vue?vue&type=template&id=363133fa&scoped=true"
import script from "./DonationDetail.vue?vue&type=script&lang=js"
export * from "./DonationDetail.vue?vue&type=script&lang=js"
import style0 from "./DonationDetail.vue?vue&type=style&index=0&id=363133fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363133fa",
  null
  
)

export default component.exports